<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create person</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label
                    for="title"
                    class="col-md-2"
                    title="CMS specific field. This will appear on a search page as a snippet title."
                  >
                    Content type title*
                  </label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="salutation" class="col-md-2">Salutation</label>
                  <div class="col-md-10">
                    <input
                      id="salutation"
                      v-model="entity.name.salutation"
                      type="text"
                      placeholder="Enter salutation"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="first_name" class="col-md-2">First name</label>
                  <div class="col-md-10">
                    <input
                      id="first_name"
                      v-model="entity.name.first_name"
                      type="text"
                      placeholder="Enter first name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="middle_name" class="col-md-2">Middle name</label>
                  <div class="col-md-10">
                    <input
                      id="middle_name"
                      v-model="entity.name.middle_name"
                      type="text"
                      placeholder="Enter middle name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="last_name" class="col-md-2">Last name</label>
                  <div class="col-md-10">
                    <input
                      id="last_name"
                      v-model="entity.name.last_name"
                      type="text"
                      placeholder="Enter last name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="maiden_name" class="col-md-2">Maiden name</label>
                  <div class="col-md-10">
                    <input
                      id="maiden_name"
                      v-model="entity.name.maiden_name"
                      type="text"
                      placeholder="Enter maiden name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="maiden_name" class="col-md-2">Suffix</label>
                  <div class="col-md-10">
                    <input
                      id="suffix"
                      v-model="entity.name.suffix"
                      type="text"
                      placeholder="Enter suffix"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="full_name" class="col-md-2">Full name</label>
                  <div class="col-md-10">
                    <input
                      id="full_name"
                      v-model="entity.name.full_name"
                      type="text"
                      placeholder="Enter full name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="generic_name" class="col-md-2">Nickname</label>
                  <div class="col-md-10">
                    <input
                      id="generic_name"
                      v-model="entity.name.generic_name"
                      type="text"
                      placeholder="Enter generic name"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="gender" class="col-md-2">Gender</label>
                  <div class="col-md-10">
                    <select id="gender" v-model="entity.gender" class="form-control">
                      <option v-for="(item, index) in genderOptions" :key="item" :value="item">
                        {{ index }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2">Birthday date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-if="entity.hasOwnProperty('birthday_date')"
                      v-model="entity.birthday_date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2">Death date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-if="entity.hasOwnProperty('death_date')"
                      v-model="entity.death_date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2">Marriage date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-if="entity.hasOwnProperty('marriage_date')"
                      v-model="entity.marriage_date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="degree" class="col-md-2">Academic degree</label>
                  <div class="col-md-10">
                    <input
                      id="degree"
                      v-model="entity.position.degree"
                      type="text"
                      placeholder="Enter academic degree"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="institution" class="col-md-2">Institution</label>
                  <div class="col-md-10">
                    <input
                      id="institution"
                      v-model="entity.position.institution"
                      type="text"
                      placeholder="Enter institution"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Bio</label>
                  <div class="col-md-10">
                    <ckeditor id="bio" v-model="entity.bio" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Thumbnail</label>
                  <div class="col-md-10">
                    <image-uploader
                      @changeFile="avatarUploaded"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Person has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Referencer from '@/global/components/Referencer';
import Datepicker from '@/global/components/Datepicker';
import Terms from '@/global/components/TermsEditor';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'PersonNew',

  components: {
    referencer: Referencer,
    datepicker: Datepicker,
    terms: Terms,
  },

  mixins: [CreatePageMixin],

  data() {
    return {
      genderOptions: {
        none: null,
        male: true,
        female: false,
      },
      entity: {
        title: null,
        bio: null,
        gender: null,
        birthday_date: null,
        death_date: null,
        marriage_date: null,
        position: {
          degree: null,
          institution: null,
        },
        name: {
          full_name: '',
          last_name: '',
          first_name: '',
          middle_name: '',
          maiden_name: '',
          generic_name: '',
          salutation: '',
          suffix: '',
        },
        avatar: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
    };
  },

  watch: {
    'entity.name.salutation': function () {
      this.generateFullName();
    },
    'entity.name.first_name': function () {
      this.generateFullName();
    },
    'entity.name.middle_name': function () {
      this.generateFullName();
    },
    'entity.name.last_name': function () {
      this.generateFullName();
    },
    'entity.name.maiden_name': function () {
      this.generateFullName();
    },
    'entity.name.suffix': function () {
      this.generateFullName();
    },
  },

  methods: {
    isEntityValid() {
      // @todo: update and use mixin func
      const validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.birthday_date !== null
          && this.entity.death_date !== null
          && moment(this.entity.birthday_date).isAfter(this.entity.death_date)
      ) {
        this.$_showError('Birth date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null
          && this.entity.marriage_date !== null
          && moment(this.entity.birthday_date).isAfter(this.entity.marriage_date)
      ) {
        this.$_showError('Birth date cant be more than marriage date');
        this.saveErrorMessage = 'Birth date cant be more than marriage date';
        return false;
      }
      if (this.entity.marriage_date !== null
          && this.entity.death_date !== null
          && moment(this.entity.marriage_date).isAfter(this.entity.death_date)
      ) {
        this.$_showError('Marriage date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null
          && this.entity.marriage_date !== null
          && moment(this.entity.birthday_date).isAfter(this.entity.marriage_date)
      ) {
        this.$_showError('Birth date cant be less than marriage date');
        return false;
      }
      if (this.entity.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.bio) postFormData.append('bio', this.entity.bio);
      if (this.entity.birthday_date) postFormData.append('birthday_date', this.entity.birthday_date);
      if (this.entity.death_date) postFormData.append('death_date', this.entity.death_date);
      if (this.entity.marriage_date) postFormData.append('marriage_date', this.entity.marriage_date);
      if (this.entity.gender) postFormData.append('gender', this.entity.gender);
      if (this.entity.name.full_name) postFormData.append('full_name', this.entity.name.full_name);
      if (this.entity.name.last_name) postFormData.append('last_name', this.entity.name.last_name);
      if (this.entity.name.first_name) postFormData.append('first_name', this.entity.name.first_name);
      if (this.entity.name.maiden_name) postFormData.append('maiden_name', this.entity.name.maiden_name);
      if (this.entity.name.middle_name) postFormData.append('middle_name', this.entity.name.middle_name);
      if (this.entity.name.generic_name) postFormData.append('generic_name', this.entity.name.generic_name);
      if (this.entity.name.salutation) postFormData.append('salutation', this.entity.name.salutation);
      if (this.entity.name.suffix) postFormData.append('suffix', this.entity.name.suffix);
      if (this.entity.position.degree) postFormData.append('degree', this.entity.position.degree);
      if (this.entity.position.institution) postFormData.append('institution', this.entity.position.institution);
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}people`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/content/person/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in person update migration', error);
        this.$_errorSave(error);
      });
    },
    avatarUploaded(file) {
      this.entity.avatar = file;
    },
    generateFullName() {
      // eslint-disable-next-line
      const { salutation, first_name, middle_name, last_name, maiden_name, suffix } = this.entity.name;
      // eslint-disable-next-line
      this.entity.name.full_name = `${salutation} ${first_name} ${middle_name} ${last_name} ${maiden_name} ${suffix}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?eabafcf6